import {Component, TemplateRef, ViewChild, HostListener, OnInit} from '@angular/core';

import {Sort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {FinalizeOrderComponent} from './finalize.order.component';
import {CertinomisApiService} from './certinomis.api.service';
import {ProductDetailComponent} from './product.detail.component';


@Component({
  selector: 'app-certinomis',
  templateUrl: './certinomis.component.html',
  styleUrls: ['./certinomis.component.css'],
})

export class CertinomisComponent {
  @ViewChild('modalTemplate') modalTemplate: TemplateRef<any>;

  productsList = [];

  constructor(
    public dialog: MatDialog,
    public apiService: CertinomisApiService
  ) {
    this.apiService.getAllCertificate().subscribe(
      data => {
        console.log(data);
        // @ts-ignore
        this.productsList = data.certificates.content;
      },
      err => {
      }
    );
    // this.productsList = [
    //   {
    //     "reference": "OPE-AES-CAP-1A",
    //     "name": "Décideur - 1 an",
    //     "duration": 365,
    //     "hsm": false,
    //     "price": 11000,
    //     "usages": [
    //       "Appels d’offres",
    //       "Téléservice SYLAé"
    //     ],
    //     "support": {
    //       "image": "card",
    //       "description": "Carte à cryptoprocesseur Gemalto MD 940, qualifiée au niveau renforcé ANSSI, qualifiée QSCD, certifiée CC EAL 5+"
    //     },
    //     "certifications": [
    //       "Certificat de signature qualifié eIDAS",
    //       "Certification ETSI 319 411-1 niveau NCP+ (certificat d’authentification)",
    //       "Certification ETSI 319 411-2 niveau QCP+ (certificat de signature)",
    //       "Qualification RGS au niveau 2 étoiles",
    //       "Signatures reconnues nativement par Adobe (PDF Reader)"
    //     ],
    //     "description": "<p>Ce certificat est &eacute;tabli au nom d&rsquo;une personne physique agissant au nom d&rsquo;une personne morale ; il est utilisable pour : <br />&ndash; Contr&ocirc;le d&rsquo;acc&egrave;s &agrave; un syst&egrave;me d&rsquo;information <br />&ndash; signature de documents &eacute;lectroniques (signature dite de &laquo; niveau 4 &raquo;)</p>",
    //     "features": [
    //       {
    //         "name": "OID de la PC",
    //         "value": "1.2.250.1.86.2.6.3.1.1, 1.2.250.1.86.2.6.3.2.1 ( Certificat de signature)"
    //       },
    //       {
    //         "name": "Durée de vie",
    //         "value": "1 an, 2 ans, 3 ans"
    //       },
    //       {
    //         "name": "Longeur des clés",
    //         "value": "2048 bits"
    //       },
    //       {
    //         "name": "Usage de la clé",
    //         "value": "Content Commitment (certificat de signature), Digital Signature (certificat d’authentification)"
    //       },
    //       {
    //         "name": "Algorithme de hachage",
    //         "value": "SHA2"
    //       },
    //       {
    //         "name": "Autorité de Certification",
    //         "value": "Certinomis Prime G2"
    //       }
    //     ],
    //     "browsers": [
    //       {
    //         "image": "edge",
    //         "name": "Microsoft Edge"
    //       },
    //       {
    //         "image": "firefox",
    //         "name": "Mozilla Firefox"
    //       },
    //       {
    //         "image": "chrome",
    //         "name": "Chrome (ce navigateur n'est pas utilisable avec SYLAé)"
    //       },
    //       {
    //         "image": "safari",
    //         "name": "Safari"
    //       }
    //     ],
    //     "server": false,
    //     "professional": true,
    //     "range_reference": "O2E",
    //     "is_professional": true,
    //     "needs_identity": true,
    //     "digital_signature_only": null,
    //     "has_delegations": false,
    //     "is_server": false,
    //     "server_type": "",
    //     "server_scope": "",
    //     "server_has_csr": false,
    //     "memory_card": false,
    //     "request_type": "cms",
    //     "delivery_modes": [
    //       "post_office"
    //     ],
    //     "no_representative_needed": false,
    //     "windows_versions": [
    //       "Windows 7 – 32bits et 64 bits",
    //       "Windows 8 dont N et PRO (RT non supporté)",
    //       "Windows 10 (RT non supporté)",
    //       "Certinomis n'assure pas le support pour les clients légers (environnements TSE, Citrix etc.)"
    //     ],
    //     "macos_versions": [
    //       "Mac OS X",
    //       "Signature incompatible sur MAC OS X MOJAVE"
    //     ],
    //     "linux_versions": [],
    //     "options_products": [
    //       {
    //         "reference": "AT005",
    //         "type": "reader",
    //         "price": 2000,
    //         "name": "Lecteur format clé USB",
    //         "description": "Si vous n'en avez pas encore, il est indispensable d'acquérir un lecteur pour vos certificats"
    //       },
    //       {
    //         "reference": "FRAISDD",
    //         "type": "express",
    //         "price": 5000,
    //         "name": "Traitement et envoi express",
    //         "description": "Le traitement express permet un traitement prioritaire de votre dossier ; le certificat est envoyé dans les 48H en Chronopost après réception du dossier complet"
    //       }
    //     ]
    //   },
    //   {
    //     "reference": "OPE-AES-CAP-2A",
    //     "name": "Décideur - 2 ans",
    //     "duration": 730,
    //     "hsm": false,
    //     "price": 18000,
    //     "usages": [
    //       "Appels d’offres",
    //       "Téléservice SYLAé"
    //     ],
    //     "support": {
    //       "image": "card",
    //       "description": "Carte à cryptoprocesseur Gemalto MD 940, qualifiée au niveau renforcé ANSSI, qualifiée QSCD, certifiée CC EAL 5+"
    //     },
    //     "certifications": [
    //       "Certificat de signature qualifié eIDAS",
    //       "Certification ETSI 319 411-1 niveau NCP+ (certificat d’authentification)",
    //       "Certification ETSI 319 411-2 niveau QCP+ (certificat de signature)",
    //       "Qualification RGS au niveau 2 étoiles",
    //       "Signatures reconnues nativement par Adobe (PDF Reader)"
    //     ],
    //     "description": "<p>Ce certificat est &eacute;tabli au nom d&rsquo;une personne physique agissant au nom d&rsquo;une personne morale ; il est utilisable pour : <br />&ndash; Contr&ocirc;le d&rsquo;acc&egrave;s &agrave; un syst&egrave;me d&rsquo;information <br />&ndash; signature de documents &eacute;lectroniques (signature dite de &laquo; niveau 4 &raquo;)</p>",
    //     "features": [
    //       {
    //         "name": "Durée de vie",
    //         "value": "1 an, 2 ans, 3 ans"
    //       },
    //       {
    //         "name": "Longeur des clés",
    //         "value": "2048 bits"
    //       },
    //       {
    //         "name": "Usage de la clé",
    //         "value": "Content Commitment (certificat de signature), Digital Signature (certificat d’authentification)"
    //       },
    //       {
    //         "name": "Algorithme de hachage",
    //         "value": "SHA2"
    //       },
    //       {
    //         "name": "Autorité de Certification",
    //         "value": "Certinomis Prime G2"
    //       },
    //       {
    //         "name": "OID de la PC",
    //         "value": "1.2.250.1.86.2.6.3.1.1, 1.2.250.1.86.2.6.3.2.1 ( Certificat de signature)"
    //       }
    //     ],
    //     "browsers": [
    //       {
    //         "image": "edge",
    //         "name": "Microsoft Edge"
    //       },
    //       {
    //         "image": "firefox",
    //         "name": "Mozilla Firefox"
    //       },
    //       {
    //         "image": "safari",
    //         "name": "Safari"
    //       },
    //       {
    //         "image": "chrome",
    //         "name": "Chrome(ce navigateur n'est pas utilisable avec SYLAé)"
    //       }
    //     ],
    //     "server": false,
    //     "professional": true,
    //     "range_reference": "O2E",
    //     "is_professional": true,
    //     "needs_identity": true,
    //     "digital_signature_only": null,
    //     "has_delegations": false,
    //     "is_server": false,
    //     "server_type": "",
    //     "server_scope": "",
    //     "server_has_csr": false,
    //     "memory_card": false,
    //     "request_type": "cms",
    //     "delivery_modes": [
    //       "post_office"
    //     ],
    //     "no_representative_needed": false,
    //     "windows_versions": [
    //       "Windows 7 – 32bits et 64 bits",
    //       "Windows 8 dont N et PRO (RT non supporté)",
    //       "Windows 10 (RT non supporté)",
    //       "Certinomis n'assure pas le support pour les clients légers (environnements TSE, Citrix etc.)"
    //     ],
    //     "macos_versions": [
    //       "Mac OS X",
    //       "Signature incompatible sur MAC OS X MOJAVE"
    //     ],
    //     "linux_versions": [],
    //     "options_products": [
    //       {
    //         "reference": "AT005",
    //         "type": "reader",
    //         "price": 2000,
    //         "name": "Lecteur format clé USB",
    //         "description": "Si vous n'en avez pas encore, il est indispensable d'acquérir un lecteur pour vos certificats"
    //       },
    //       {
    //         "reference": "FRAISDD",
    //         "type": "express",
    //         "price": 5000,
    //         "name": "Traitement et envoi express",
    //         "description": "Le traitement express permet un traitement prioritaire de votre dossier ; le certificat est envoyé dans les 48H en Chronopost après réception du dossier complet"
    //       }
    //     ]
    //   },
    //   {
    //     "reference": "OPE-AES-CAP-3A",
    //     "name": "Décideur - 3 ans",
    //     "duration": 1095,
    //     "hsm": false,
    //     "price": 25500,
    //     "usages": [
    //       "Appels d’offres",
    //       "Téléservice SYLAé"
    //     ],
    //     "support": {
    //       "image": "card",
    //       "description": "Carte à cryptoprocesseur Gemalto MD 940, qualifiée au niveau renforcé ANSSI, qualifiée QSCD, certifiée CC EAL 5+"
    //     },
    //     "certifications": [
    //       "Certificat de signature qualifié eIDAS",
    //       "Certification ETSI 319 411-1 niveau NCP+ (certificat d’authentification)",
    //       "Certification ETSI 319 411-2 niveau QCP+ (certificat de signature)",
    //       "Qualification RGS au niveau 2 étoiles",
    //       "Signatures reconnues nativement par Adobe (PDF Reader)"
    //     ],
    //     "description": "<p>Ce certificat est &eacute;tabli au nom d&rsquo;une personne physique agissant au nom d&rsquo;une personne morale ; il est utilisable pour : <br />&ndash; Contr&ocirc;le d&rsquo;acc&egrave;s &agrave; un syst&egrave;me d&rsquo;information <br />&ndash; signature de documents &eacute;lectroniques (signature dite de &laquo; niveau 4 &raquo;)</p>",
    //     "features": [
    //       {
    //         "name": "Durée de vie",
    //         "value": "1 an, 2 ans, 3 ans"
    //       },
    //       {
    //         "name": "Longeur des clés",
    //         "value": "2048 bits"
    //       },
    //       {
    //         "name": "Usage de la clé",
    //         "value": "Content Commitment (certificat de signature), Digital Signature (certificat d’authentification)"
    //       },
    //       {
    //         "name": "Algorithme de hachage",
    //         "value": "SHA2"
    //       },
    //       {
    //         "name": "Autorité de Certification",
    //         "value": "Certinomis Prime G2"
    //       },
    //       {
    //         "name": "OID de la PC",
    //         "value": "1.2.250.1.86.2.6.3.1.1, 1.2.250.1.86.2.6.3.2.1 ( Certificat de signature)"
    //       }
    //     ],
    //     "browsers": [
    //       {
    //         "image": "edge",
    //         "name": "Microsoft Edge"
    //       },
    //       {
    //         "image": "firefox",
    //         "name": "Mozilla Firefox"
    //       },
    //       {
    //         "image": "safari",
    //         "name": "Safari"
    //       },
    //       {
    //         "image": "chrome",
    //         "name": "Chrome(ce navigateur n'est pas utilisable avec SYLAé)"
    //       }
    //     ],
    //     "server": false,
    //     "professional": true,
    //     "range_reference": "O2E",
    //     "is_professional": true,
    //     "needs_identity": true,
    //     "digital_signature_only": null,
    //     "has_delegations": false,
    //     "is_server": false,
    //     "server_type": "",
    //     "server_scope": "",
    //     "server_has_csr": false,
    //     "memory_card": false,
    //     "request_type": "cms",
    //     "delivery_modes": [
    //       "post_office"
    //     ],
    //     "no_representative_needed": false,
    //     "windows_versions": [
    //       "Windows 7 – 32bits et 64 bits",
    //       "Windows 8 dont N et PRO (RT non supporté)",
    //       "Windows 10 (RT non supporté)",
    //       "Certinomis n'assure pas le support pour les clients légers (environnements TSE, Citrix etc.)"
    //     ],
    //     "macos_versions": [
    //       "Mac OS X",
    //       "Signature incompatible sur MAC OS X MOJAVE"
    //     ],
    //     "linux_versions": [],
    //     "options_products": [
    //       {
    //         "reference": "AT005",
    //         "type": "reader",
    //         "price": 2000,
    //         "name": "Lecteur format clé USB",
    //         "description": "Si vous n'en avez pas encore, il est indispensable d'acquérir un lecteur pour vos certificats"
    //       },
    //       {
    //         "reference": "FRAISDD",
    //         "type": "express",
    //         "price": 5000,
    //         "name": "Traitement et envoi express",
    //         "description": "Le traitement express permet un traitement prioritaire de votre dossier ; le certificat est envoyé dans les 48H en Chronopost après réception du dossier complet"
    //       },
    //       {
    //         "reference": "OPE-SRY-CAP-3A",
    //         "type": "serenity",
    //         "price": 3500,
    //         "name": "Option Sérénité",
    //         "description": "Remplacement ou déblocage gratuit en cas de perte / vol de la carte ou blocage du code PIN dans la limite de 3 opérations"
    //       }
    //     ]
    //   },
    //   {
    //     "reference": "OAA-AGT-CAP-1A",
    //     "name": "Agents - 1 an",
    //     "duration": 365,
    //     "hsm": false,
    //     "price": 10000,
    //     "usages": [
    //       "Certificat d’Authentification",
    //       "Transmission ACTES"
    //     ],
    //     "support": {
    //       "image": "card",
    //       "description": "Carte à cryptoprocesseur Gemalto MD 940C, qualifiée au niveau renforcé ANSSI, qualifiée QSCD, certifiée CC EAL 5+"
    //     },
    //     "certifications": [
    //       "Certification ETSI 319 411-1 niveau NCP+",
    //       "Qualification RGS au niveau 2 étoiles"
    //     ],
    //     "description": "Ce certificat est établi au nom d’une personne physique agissant au nom d’une personne morale ; il est utilisable pour :  <br>– Contrôle d’accès à un système d’information  <br>– Accès limité à la consultation sur les téléservices ou les plates-formes transactionnelles (Transmission ACTES par exemple).  <br>–Certificat d’authentification",
    //     "features": [
    //       {
    //         "name": "Longeur des clés",
    //         "value": "4096 bits"
    //       },
    //       {
    //         "name": "Durée de vie",
    //         "value": "1 an, 2 ans, 3 ans"
    //       },
    //       {
    //         "name": "Usage de la clé",
    //         "value": "Digital Signature"
    //       },
    //       {
    //         "name": "Algorithme de hachage",
    //         "value": "SHA2"
    //       },
    //       {
    //         "name": "Autorité de Certification",
    //         "value": "Certinomis PRIME CA G2"
    //       },
    //       {
    //         "name": "OID de la PC",
    //         "value": "1.2.250.1.86.2.6.3.1.1"
    //       }
    //     ],
    //     "browsers": [
    //       {
    //         "image": "edge",
    //         "name": "Microsoft Edge"
    //       },
    //       {
    //         "image": "firefox",
    //         "name": "Mozilla Firefox"
    //       },
    //       {
    //         "image": "safari",
    //         "name": "Safari"
    //       },
    //       {
    //         "image": "chrome",
    //         "name": "Chrome (ce navigateur n'est pas utilisable avec SYLAé)"
    //       }
    //     ],
    //     "server": false,
    //     "professional": true,
    //     "range_reference": "OAA",
    //     "is_professional": true,
    //     "needs_identity": true,
    //     "digital_signature_only": null,
    //     "has_delegations": false,
    //     "is_server": false,
    //     "server_type": "",
    //     "server_scope": "",
    //     "server_has_csr": false,
    //     "memory_card": false,
    //     "request_type": "cms",
    //     "delivery_modes": [],
    //     "no_representative_needed": false,
    //     "windows_versions": [
    //       "Windows 10 et 11",
    //       "Client Léger, TSE et RT non supportés"
    //     ],
    //     "macos_versions": [
    //       "MAC OS 14 Sonoma",
    //       "MAC OS 13 Ventura",
    //       "MAC OS 12 Monterey",
    //       "Mac OS 11 Big Sur"
    //     ],
    //     "linux_versions": [
    //       "SUSE 15",
    //       "Debian 9",
    //       "Red Hat 8 / 9",
    //       "CentOS 8 / 9",
    //       "Fedora 36 / 37",
    //       "Ubuntu 20.04 / 22.04"
    //     ],
    //     "options_products": [
    //       {
    //         "reference": "AT005",
    //         "type": "reader",
    //         "price": 2000,
    //         "name": "Lecteur format clé USB",
    //         "description": "Si vous n'en avez pas encore, il est indispensable d'acquérir un lecteur pour vos certificats"
    //       }
    //     ]
    //   },
    //   {
    //     "reference": "OAA-AGT-CAP-2A",
    //     "name": "Agents - 2 ans",
    //     "duration": 730,
    //     "hsm": false,
    //     "price": 16500,
    //     "usages": [],
    //     "support": {
    //       "image": "card",
    //       "description": "Carte à cryptoprocesseur Gemalto MD 940, qualifiée au niveau renforcé ANSSI, qualifiée QSCD, certifiée CC EAL 5+"
    //     },
    //     "certifications": [
    //       "Certification ETSI 319 411-1 niveau NCP+",
    //       "Qualification RGS au niveau 2 étoiles"
    //     ],
    //     "description": "Ce certificat est établi au nom d’une personne physique agissant au nom d’une personne morale ; il est utilisable pour :  <br>– Contrôle d’accès à un système d’information  <br>– Accès limité à la consultation sur les téléservices ou les plates-formes transactionnelles (Transmission ACTES par exemple).",
    //     "features": [
    //       {
    //         "name": "Durée de vie",
    //         "value": "1 an, 2 ans, 3 ans"
    //       },
    //       {
    //         "name": "Longeur des clés",
    //         "value": "2048 bits"
    //       },
    //       {
    //         "name": "Usage de la clé",
    //         "value": "Digital Signature"
    //       },
    //       {
    //         "name": "Algorithme de hachage",
    //         "value": "SHA2"
    //       },
    //       {
    //         "name": "Autorité de Certification",
    //         "value": "Certinomis PRIME CA G2"
    //       },
    //       {
    //         "name": "OID de la PC",
    //         "value": "1.2.250.1.86.2.6.3.1.1"
    //       }
    //     ],
    //     "browsers": [
    //       {
    //         "image": "edge",
    //         "name": "Microsoft Edge"
    //       },
    //       {
    //         "image": "firefox",
    //         "name": "Mozilla Firefox"
    //       },
    //       {
    //         "image": "safari",
    //         "name": "Safari"
    //       },
    //       {
    //         "image": "chrome",
    //         "name": "Chrome (ce navigateur n'est pas utilisable avec SYLAé)"
    //       }
    //     ],
    //     "server": false,
    //     "professional": true,
    //     "range_reference": "OAA",
    //     "is_professional": true,
    //     "needs_identity": true,
    //     "digital_signature_only": null,
    //     "has_delegations": false,
    //     "is_server": false,
    //     "server_type": "",
    //     "server_scope": "",
    //     "server_has_csr": false,
    //     "memory_card": false,
    //     "request_type": "cms",
    //     "delivery_modes": [],
    //     "no_representative_needed": false,
    //     "windows_versions": [
    //       "Windows 10 et 11",
    //       "Client Léger, TSE et RT non supportés"
    //     ],
    //     "macos_versions": [
    //       "MacOS 10.15 Catalina",
    //       "MacOs 10.14.6 Mojave",
    //       "MacOs11 Big Sur",
    //       "MacOS 12 Montery"
    //     ],
    //     "linux_versions": [
    //       "Red Hat 8(and7.6)",
    //       "CentOs 7.6(and 6.10)",
    //       "SUSE 15",
    //       "Debian 9",
    //       "Fedora 30",
    //       "Ubuntu 18.04.2 LTS and 19.04"
    //     ],
    //     "options_products": [
    //       {
    //         "reference": "AT005",
    //         "type": "reader",
    //         "price": 2000,
    //         "name": "Lecteur format clé USB",
    //         "description": "Si vous n'en avez pas encore, il est indispensable d'acquérir un lecteur pour vos certificats"
    //       },
    //       {
    //         "reference": "FRAISDD",
    //         "type": "express",
    //         "price": 5000,
    //         "name": "Traitement et envoi express",
    //         "description": "Le traitement express permet un traitement prioritaire de votre dossier ; le certificat est envoyé dans les 48H en Chronopost après réception du dossier complet"
    //       }
    //     ]
    //   },
    //   {
    //     "reference": "OAA-AGT-CAP-3A",
    //     "name": "Agents - 3 ans",
    //     "duration": 1095,
    //     "hsm": false,
    //     "price": 23000,
    //     "usages": [],
    //     "support": {
    //       "image": "card",
    //       "description": "Carte à cryptoprocesseur Gemalto MD 940, qualifiée au niveau renforcé ANSSI, qualifiée QSCD, certifiée CC EAL 5+"
    //     },
    //     "certifications": [
    //       "Certification ETSI 319 411-1 niveau NCP+",
    //       "Qualification RGS au niveau 2 étoiles"
    //     ],
    //     "description": "Ce certificat est établi au nom d’une personne physique agissant au nom d’une personne morale ; il est utilisable pour :  <br>– Contrôle d’accès à un système d’information  <br>– Accès limité à la consultation sur les téléservices ou les plates-formes transactionnelles (Transmission ACTES par exemple).",
    //     "features": [
    //       {
    //         "name": "Durée de vie",
    //         "value": "1 an, 2 ans, 3 ans"
    //       },
    //       {
    //         "name": "Longeur des clés",
    //         "value": "2048 bits"
    //       },
    //       {
    //         "name": "Usage de la clé",
    //         "value": "Digital Signature"
    //       },
    //       {
    //         "name": "Algorithme de hachage",
    //         "value": "SHA2"
    //       },
    //       {
    //         "name": "Autorité de Certification",
    //         "value": "Certinomis PRIME CA G2"
    //       },
    //       {
    //         "name": "OID de la PC",
    //         "value": "1.2.250.1.86.2.6.3.1.1"
    //       }
    //     ],
    //     "browsers": [
    //       {
    //         "image": "edge",
    //         "name": "Microsoft Edge"
    //       },
    //       {
    //         "image": "firefox",
    //         "name": "Mozilla Firefox"
    //       },
    //       {
    //         "image": "safari",
    //         "name": "Safari"
    //       },
    //       {
    //         "image": "chrome",
    //         "name": "Chrome (ce navigateur n'est pas utilisable avec SYLAé)"
    //       }
    //     ],
    //     "server": false,
    //     "professional": true,
    //     "range_reference": "OAA",
    //     "is_professional": true,
    //     "needs_identity": true,
    //     "digital_signature_only": null,
    //     "has_delegations": false,
    //     "is_server": false,
    //     "server_type": "",
    //     "server_scope": "",
    //     "server_has_csr": false,
    //     "memory_card": false,
    //     "request_type": "cms",
    //     "delivery_modes": [],
    //     "no_representative_needed": false,
    //     "windows_versions": [
    //       "Windows 10 et 11",
    //       "Client Léger, TSE et RT non supportés"
    //     ],
    //     "macos_versions": [
    //       "MacOS 10.15 Catalina",
    //       "MacOs 10.14.6 Mojave",
    //       "MacOs11 Big Sur",
    //       "MacOS 12 Montery"
    //     ],
    //     "linux_versions": [
    //       "Red Hat 8(and7.6)",
    //       "CentOs 7.6(and 6.10)",
    //       "SUSE 15",
    //       "Debian 9",
    //       "Fedora 30",
    //       "Ubuntu 18.04.2 LTS and 19.04"
    //     ],
    //     "options_products": [
    //       {
    //         "reference": "AT005",
    //         "type": "reader",
    //         "price": 2000,
    //         "name": "Lecteur format clé USB",
    //         "description": "Si vous n'en avez pas encore, il est indispensable d'acquérir un lecteur pour vos certificats"
    //       },
    //       {
    //         "reference": "FRAISDD",
    //         "type": "express",
    //         "price": 5000,
    //         "name": "Traitement et envoi express",
    //         "description": "Le traitement express permet un traitement prioritaire de votre dossier ; le certificat est envoyé dans les 48H en Chronopost après réception du dossier complet"
    //       },
    //       {
    //         "reference": "OPE-SRY-CAP-3A",
    //         "type": "serenity",
    //         "price": 3500,
    //         "name": "Option Sérénité",
    //         "description": "Remplacement ou déblocage gratuit en cas de perte / vol de la carte ou blocage du code PIN dans la limite de 3 opérations"
    //       }
    //     ]
    //   }
    // ]

  }

  finalizeOrder(product: string) {
    const dialogRef = this.dialog.open(FinalizeOrderComponent, {
      width: '90%', // Largeur fixe
      maxHeight: '100%', // Limite la hauteur à la vue (full height)
      panelClass: 'custom-dialog-container', // Classe CSS personnalisée
      data: {
        product: product
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        console.log('Commande validée.');
        // Logique après confirmation de la commande
      } else {
        console.log('Action annulée.');
      }
    });
  }


  productDetail(product: string) {
    const dialogRef = this.dialog.open(ProductDetailComponent, {
      width: '550px', // Largeur fixe
      // panelClass: 'custom-dialog-container', // Classe CSS personnalisée
      data: {
        product: product
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

}


